// Generated by scripts/mdi/import-questionnaires.mjs from MDI "BPC-157 / Thymosin beta 4 09.17.26" (8d56cb60-fef9-4c63-a9b5-5fefcc3da8a7). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiBPC157ThymosinBeta4Questions = [
  {
    field: 'mdiBPC157ThymosinBeta4_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_wereSorryTreatmentNotMedically',
    label:
      "We're sorry, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'd24bd21c-74fa-4109-8c1d-1a790e706b05',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1R4XpaJovs9UzJWPnVh11WFfw2S4ViKJb/view)',
    answer: {
      type: 'text',
      name: 'mdiBPC157ThymosinBeta4_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '4876bbde-9692-420f-8ad9-1f3c781e0370' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'tendon_injuries_and_tears',
          value: 'Tendon injuries and tears'
        },
        { key: 'ligament_damage', value: 'Ligament damage' },
        { key: 'muscle_tears_and_strains', value: 'Muscle tears and strains' },
        { key: 'bone_fractures', value: 'Bone fractures' },
        {
          key: 'joint_inflammation_and_arthritis',
          value: 'Joint inflammation and arthritis'
        },
        {
          key: 'gastrointestinal_ulcers_and_inflammatory',
          value: 'Gastrointestinal ulcers and inflammatory bowel disease'
        },
        { key: 'post_surgical_healing', value: 'Post-surgical healing' },
        {
          key: 'nerve_protection_and_repair',
          value: 'Nerve protection and repair'
        },
        {
          key: 'accelerated_wound_healing_and_tissue_rep',
          value: 'Accelerated wound healing and tissue repair'
        },
        {
          key: 'reduced_inflammation_in_acute_and_chroni',
          value: 'Reduced inflammation in acute and chronic conditions'
        },
        {
          key: 'decreased_scar_formation_and_improved_co',
          value: 'Decreased scar formation and improved cosmetic outcomes'
        },
        {
          key: 'cardiac_tissue_protection_and_repair_fol',
          value:
            'Cardiac tissue protection and repair following heart attack (myocardial infarction)'
        },
        {
          key: 'improved_outcomes_in_congenital_heart_su',
          value: 'Improved outcomes in congenital heart surgery'
        },
        {
          key: 'support_for_spinal_cord_injuries_and_tra',
          value:
            'Support for spinal cord injuries and traumatic brain injury recovery'
        },
        { key: 'eye_health_benefits', value: 'Eye health benefits' },
        {
          key: 'nerve_tissue_regeneration_and_neuroprote',
          value: 'Nerve tissue regeneration and neuroprotection'
        },
        {
          key: 'improved_flexibility_and_range_of_motion',
          value: 'Improved flexibility and range of motion'
        },
        {
          key: 'support_for_autoimmune_and_inflammatory',
          value: 'Support for autoimmune and inflammatory conditions'
        }
      ]
    },
    extras: { mdiQuestionId: '108bd812-437c-423f-b1b5-da2d0364ec24' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '9a4189a2-09a7-4261-8e22-c29b55b76cf2' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiBPC157ThymosinBeta4_peptidesUsedPreviously',
      rows: 4
    },
    extras: { mdiQuestionId: '9c9a03a3-131d-43ac-bef8-d13ff5602e01' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '820cdc78-8d57-400f-a482-9b5a1337c506' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiBPC157ThymosinBeta4_reactionSideEffect',
      rows: 4
    },
    extras: { mdiQuestionId: 'c184895a-ed69-4aa4-adfd-5175daab478e' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        {
          key: 'any_condition_that_causes_advanced_fibro',
          value: 'Any condition that causes advanced fibrosis'
        },
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_such_as_heart_att',
          value: 'Cardiovascular disease such as heart attack, stroke, etc'
        },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'aneurysm', value: 'Aneurysm' },
        { key: 'thrombosis_blood_clots', value: 'Thrombosis/blood clots' },
        { key: 'psychiatric_illness', value: 'Psychiatric illness' },
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '4c4b81b1-850d-40ed-b087-5c21ca9e52f8' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: 'd0a36bb1-6ef2-478e-a2ef-1b77ecf3af8e' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'adhd_medication_such_as_adderall_or_vyva',
          value: 'ADHD medication (such as adderall or vyvanse)'
        },
        { key: 'antiviral_medication', value: 'Antiviral medication' },
        {
          key: 'beta_blockers_such_as_metoprolol_or_prop',
          value: 'Beta blockers  (such as metoprolol or propranolol)'
        },
        {
          key: 'chemotherapy_or_cancer_related_treatment',
          value: 'Chemotherapy or cancer-related treatment'
        },
        {
          key: 'alpha_blockers_such_as_razosin_or_doxazo',
          value: 'Alpha blockers (such as razosin or doxazosin)'
        },
        {
          key: 'corticosteroids_like_prednisone_dexameth',
          value: 'Corticosteroids (like prednisone, dexamethasone, etc)'
        },
        {
          key: 'dopamine_agonists_such_as_pramipexole_or',
          value: 'Dopamine agonists (such as pramipexole or bromocriptine)'
        },
        {
          key: 'parkinsons_medications_such_as_carbidopa',
          value: 'Parkinson’s medications (such as carbidopa/levodopa)'
        },
        { key: 'nitrate_medications', value: 'Nitrate medications' },
        {
          key: 'antipsychotic_medications_such_as_halope',
          value:
            'Antipsychotic medications (such as haloperidol or risperidone)'
        },
        {
          key: 'pde_5_inhibitors_such_as_sildenafil_or_t',
          value: 'PDE-5 inhibitors (such as sildenafil or tadalafil)'
        },
        { key: 'warfarin', value: 'Warfarin' },
        {
          key: 'blood_thinners_such_as_eliquis_or_xarelt',
          value: 'Blood thinners (such as eliquis or xarelto)'
        },
        {
          key: 'aspirin_clopidogrel_or_any_other_antipla',
          value: 'Aspirin, clopidogrel, or any other antiplatelet medication'
        },
        { key: 'immunosuppressants', value: 'Immunosuppressants' },
        { key: 'tnf_inhibitors', value: 'TNF inhibitors' },
        { key: 'calcineurin_inhibitors', value: 'Calcineurin inhibitors' },
        { key: 'alcohol_use', value: 'Alcohol use' },
        { key: 'growth_factor_peptides', value: 'Growth factor peptides' },
        { key: 'nsaids', value: 'NSAIDs' },
        { key: 'methotrexate', value: 'Methotrexate' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'bf670839-77cd-4df5-9d4b-b40011ad5714' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '197b9d13-c671-492d-b169-5e266b0f7e05' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '25dad366-fbaa-4a62-b08a-c15700847db4' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiBPC157ThymosinBeta4_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '2080f5b4-16a6-4d55-b864-a0c245c6712f' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiBPC157ThymosinBeta4_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: 'e37de8d8-497a-4797-89a9-355a1b516a98' }
  },
  {
    field: 'mdiBPC157ThymosinBeta4_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiBPC157ThymosinBeta4AnswerField = Partial<
  QuestionAnswerMap<typeof mdiBPC157ThymosinBeta4Questions>
>;

export default mdiBPC157ThymosinBeta4Questions;
